import { call, put, select, takeEvery } from 'redux-saga/effects';
import { registerBanner } from 'features/Banners/BannerHost';
import { addAnnouncement, selectBannerToDisplay } from 'features/Banners/Banners.reducer';
import { OfferBanner } from 'features/Offer/OfferBanner/OfferBanner';
import { shouldDisallowOfferExperience } from 'redux/saga/helpers/promotions';
import { readLocalStorage } from 'redux/saga/helpers/local-storage';
import { setPagePromotion } from 'redux/modules/page';
import { LS_OFFER_BANNER_KEY, OFFER_BANNER_ID } from 'constants/promotions';

/**
 * The offer banner should not be the highest priority for banners as this loads
 * for almost every page while the other banners load for specific states or actions.
 */
function* addOfferBanner() {
  yield call(registerBanner, 'OfferBanner', OfferBanner);
  yield put(
    addAnnouncement(
      OFFER_BANNER_ID,
      'OfferBanner',
      {},
      {
        priority: 0,
        showBannerOnAllPages: true,
        suppressible: true,
      }
    )
  );
}

export function* addOfferBannerFromPagePromotion(client) {
  const currentBanner = yield select(selectBannerToDisplay, 'announcement');
  const isUsertNotInOfferExp = yield call(shouldDisallowOfferExperience, client);
  if (isUsertNotInOfferExp || currentBanner) {
    return;
  }
  yield call(addOfferBanner);
}

/**
 * Because we initially add a offer banner on a page if a promotion exists, we want that
 * offer banner to be maintained if a user opens a page that doesn't set a promotion in a
 * new tab/window or if we do a hard refresh when linking to that page. This function ensures
 * that we add the offer banner on initial load if an offer exists in local storage.
 */
export function* addOfferBannerFromInitialLoad(client) {
  const doesOfferInLSExist = yield call(readLocalStorage, LS_OFFER_BANNER_KEY);
  const isUserInOfferExp = !(yield call(shouldDisallowOfferExperience, client));
  if (doesOfferInLSExist && isUserInOfferExp) {
    yield call(addOfferBanner);
  }
}

export function* loadSaga(client) {
  yield call(addOfferBannerFromInitialLoad, client);
}

export function* watchSaga(client) {
  yield takeEvery(setPagePromotion().type, addOfferBannerFromPagePromotion, client);
}
